import { render, staticRenderFns } from "./practice-folder.vue?vue&type=template&id=8d7369be&scoped=true&"
import script from "./practice-folder.vue?vue&type=script&lang=ts&"
export * from "./practice-folder.vue?vue&type=script&lang=ts&"
import style0 from "./practice-folder.vue?vue&type=style&index=0&id=8d7369be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7369be",
  null
  
)

export default component.exports